"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _framerMotion = require("framer-motion");
var Accordion = _interopRequireWildcard(require("@radix-ui/react-accordion"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _mixins = require("../../styles/mixins");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _useAccordionAnimation = require("../common/useAccordionAnimation");
var _excluded = ["children", "defaultValue", "value", "onValueChange"],
  _excluded2 = ["value", "children"],
  _excluded3 = ["children", "id", "testId", "testIdName"],
  _excluded4 = ["children", "style", "forceMount", "className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var RootContext = /*#__PURE__*/(0, _react.createContext)(null);
var ItemContext = /*#__PURE__*/(0, _react.createContext)(null);
var Root = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    defaultValue = _ref.defaultValue,
    externalValue = _ref.value,
    onExternalValueChange = _ref.onValueChange,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(defaultValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    internalValue = _useState2[0],
    onInternalValueChange = _useState2[1];
  var value = onExternalValueChange ? externalValue : internalValue;
  var onValueChange = onExternalValueChange || onInternalValueChange;
  return /*#__PURE__*/_react["default"].createElement(Accordion.Root, (0, _extends2["default"])({
    ref: ref,
    value: value,
    onValueChange: onValueChange
  }, props), /*#__PURE__*/_react["default"].createElement(RootContext.Provider, {
    value: {
      value: value
    }
  }, children));
});
var StyledItem = (0, _styledComponents["default"])(Accordion.Item).withConfig({
  displayName: "HBAccordionNew__StyledItem",
  componentId: "sc-1et8yg3-0"
})(["", ""], _mixins.inheritBorderRadiusColumn);
var Item = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var itemValue = _ref2.value,
    children = _ref2.children,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var _useContext = (0, _react.useContext)(RootContext),
    rootValue = _useContext.value;
  var isExpanded = Array.isArray(rootValue) ? rootValue.includes(itemValue) : rootValue === itemValue;
  return /*#__PURE__*/_react["default"].createElement(StyledItem, (0, _extends2["default"])({
    value: itemValue,
    ref: ref
  }, props), /*#__PURE__*/_react["default"].createElement(ItemContext.Provider, {
    value: {
      isExpanded: isExpanded
    }
  }, children));
});
var Trigger = /*#__PURE__*/(0, _react.forwardRef)(function (_ref3, ref) {
  var children = _ref3.children,
    id = _ref3.id,
    testId = _ref3.testId,
    testIdName = _ref3.testIdName,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id,
    suffix: 'accordion-trigger',
    componentName: 'HBAccordionNew'
  });
  return /*#__PURE__*/_react["default"].createElement(StyledTrigger, (0, _extends2["default"])({
    ref: ref
  }, props, {
    "data-testid": finalTestId
  }), children);
});
var Content = /*#__PURE__*/(0, _react.forwardRef)(function (_ref4, ref) {
  var children = _ref4.children,
    style = _ref4.style,
    _ref4$forceMount = _ref4.forceMount,
    forceMount = _ref4$forceMount === void 0 ? true : _ref4$forceMount,
    className = _ref4.className,
    props = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  var context = (0, _react.useContext)(ItemContext);
  var animation = (0, _useAccordionAnimation.useAccordionAnimation)(forceMount ? context : undefined);
  return /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, {
    initial: false
  }, (forceMount || context.isExpanded) && /*#__PURE__*/_react["default"].createElement(MotionContent, (0, _extends2["default"])({
    ref: ref,
    forceMount: true
  }, props, animation), /*#__PURE__*/_react["default"].createElement("div", {
    className: className,
    style: style
  }, children)));
});

// -------------------------- Styles -------------------------- //

var StyledTrigger = (0, _styledComponents["default"])(Accordion.Trigger).withConfig({
  displayName: "HBAccordionNew__StyledTrigger",
  componentId: "sc-1et8yg3-1"
})(["padding:0;margin:0;width:100%;text-align:initial;&,&:hover,&:focus,&:focus-visible{color:", ";background-color:unset;}&:focus-visible{outline:2px solid ", ";outline-offset:1px;}"], _colors["default"].textPrimary, _colors["default"].blue20);
var MotionContent = (0, _framerMotion.motion)(Accordion.Content);
var _default = exports["default"] = {
  Root: Root,
  Item: Item,
  Trigger: Trigger,
  Content: Content
};
//# sourceMappingURL=HBAccordionNew.js.map